import { createContext, useContext } from 'react';

const AppContext = createContext('appContext');

const useAppContext = () => {
  return useContext(AppContext);
};
export { AppContext, useAppContext };
